import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChangeModifierComponent } from './change-modifier.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    ChangeModifierComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    ChangeModifierComponent
  ]
})
export class ChangeModifierModule { }



// WEBPACK FOOTER //
// ./src/app/pages/change-modifier/change-modifier.module.ts